import {Column} from 'react-table'
import {CustomHeader} from '../../../../../../../_metronic/common/table/columns/CustomHeader'
import {StockCategory} from '../../core/_models'
import {StockCategoryActionsCell} from './StockCategoryActionsCell'

const stockCategoryColumns: ReadonlyArray<Column<StockCategory>> = [
  {
    Header: (props) => <CustomHeader tableProps={props} title='Name' className='min-w-125px' />,
    accessor: 'name',
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Description' className='min-w-125px' />,
    accessor: 'description',
  },
  {
    Header: (props) => <CustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />,
    id: 'actions',
    Cell: ({...props}) => <StockCategoryActionsCell id={props.data[props.row.index].id} />,
  },
]

export {stockCategoryColumns}
